module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-tab'), _vm._v(" "), _c('section', {
    class: [
      'menu-container-hide', 'd-flex' ]
  }, [_c('div', {
    staticClass: "menu-btn-container d-flex align-center justify-center",
    style: (("color:" + (_vm.globalColors.primary) + ";background-color:" + (_vm.globalColors.border))),
    on: {
      "click": _vm.toogleMenu
    }
  }, [_c('p', {
    staticClass: "menu-btn-text"
  }, [_vm._v("Categorías")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lateral",
      "mode": "out-in"
    }
  }, [(_vm.show) ? _c('menu-web', {
    staticClass: "menu-cat-hide",
    attrs: {
      "categories": _vm.eCategories
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('section', [(_vm.currentFilter) ? _c('h1', {
    staticClass: "category-title"
  }, [_vm._v(_vm._s(_vm.currentFilter.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-product"
  }, [_c('div', [_c('el-pagination', {
    staticClass: "txt-right",
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.totalPage,
      "page-size": _vm.limit,
      "current-page": _vm.currentPage
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _vm._v(" "), _c('products-categories', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mb-3",
    attrs: {
      "products": _vm.listFilters
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b5be156","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Filters.vue
// module id = 1099
// module chunks = 6